import { render, staticRenderFns } from "./countMoney-prize.vue?vue&type=template&id=640877a0&scoped=true&"
import script from "./countMoney-prize.vue?vue&type=script&lang=js&"
export * from "./countMoney-prize.vue?vue&type=script&lang=js&"
import style0 from "./countMoney-prize.vue?vue&type=style&index=0&id=640877a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640877a0",
  null
  
)

export default component.exports